import { countryTransfertService } from "../services/countryTransfertService";
import { COMPANY_INFO } from "../constants/company";
import { countryNameFr, currencyLabel, formatFeesLabel, formatNumberFr, groupRatesBySender } from "./dailyRates";

const ALERT_LABELS: Record<string, string> = {
  info: "Information",
  warning: "Important",
  success: "Bonne nouvelle",
};

export const enrichTemplateData = (templateId: string, data: Record<string, unknown>): Record<string, unknown> => {
  const enriched: Record<string, unknown> = {
    ...data,
    currentYear: new Date().getFullYear().toString(),
    company: COMPANY_INFO,
  };

  if (templateId === "announcement" && enriched.alertType) {
    enriched.alertLabel = ALERT_LABELS[String(enriched.alertType)] || "Information";
  }

  return enriched;
};

export const BACKEND_PLACEHOLDERS_HELP =
  "La salutation « Bonjour Prénom Nom, » est insérée automatiquement pour chaque destinataire. Ne la répétez pas dans le message.";

/** Date du jour : "04 Novembre 2026". */
const todayLabel = () => {
  const d = new Date();
  const month = d.toLocaleDateString("fr-FR", { month: "long" });
  return `${String(d.getDate()).padStart(2, "0")} ${month.charAt(0).toUpperCase()}${month.slice(1)} ${d.getFullYear()}`;
};

/** Charge les taux depuis l'API et les met en forme pour le modèle "daily-rates". */
const loadDailyRates = async () => {
  const rates = await countryTransfertService.getCountryTransferts(500, 0);
  return groupRatesBySender(rates || []).map((group) => ({
    senderName: countryNameFr(group.sender),
    items: group.items.map((r) => {
      const toCurrency = currencyLabel(r.country_destination?.devise);
      // Frais : "0 fcfa" tant que l'API ne renvoie pas de champ "fees"
      const fees = (r as unknown as Record<string, unknown>).fees;
      return {
        senderName: countryNameFr(r.country_sender),
        destinationName: countryNameFr(r.country_destination),
        rateLabel: `${formatNumberFr(r.rate)} ${toCurrency}`.trim(),
        feesLabel: formatFeesLabel(fees, r.country_sender?.devise),
      };
    }),
  }));
};

/**
 * Version asynchrone, utilisée par le formulaire d'email (aperçu et envoi).
 * Pour les modèles qui ont besoin de données serveur (ex. "Taux du jour").
 */
export const enrichTemplateDataAsync = async (
  templateId: string,
  data: Record<string, unknown>
): Promise<Record<string, unknown>> => {
  const enriched = enrichTemplateData(templateId, data);

  if (templateId === "daily-rates") {
    // L'aperçu fournit ses propres données fictives ; à l'envoi, on charge les vrais taux.
    if (!Array.isArray(enriched.rateGroups)) enriched.rateGroups = await loadDailyRates();
    if (!enriched.dateLabel) enriched.dateLabel = todayLabel();
  }

  return enriched;
};
